import React, { useState, useContext } from "react";
import { useLanguage } from "../LanguageContext";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../../contexts/ThemeContext";

const MainNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isStoreMegaMenuOpen, setIsStoreMegaMenuOpen] = useState(false);
  const { isRTL, toggleLanguage } = useLanguage();
  const navigate = useNavigate();
  const { isDarkMode } = useContext(ThemeContext);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleStoreMegaMenu = () => {
    setIsStoreMegaMenuOpen(!isStoreMegaMenuOpen);
  };

  const menuItems = [
    { en: "Home", ar: "الرئيسية", path: "/" },
    { en: "News", ar: "الأخبار", path: "/news" },
    { en: "Elite Club", ar: "النادي الحصري", path: "/elite-club" },
    { en: "Price Calculator", ar: "حاسبة الأسعار", path: "/price-calculator" },
    {
      en: "Dar Alsabaek Institute",
      ar: "معهد دار السبائك",
      path: "/institute",
    },
    { en: "About Us", ar: "من نحن", path: "/about" },
    { en: "Contact Us", ar: "اتصل بنا", path: "/contact" },
  ];

  const storeItems = [
    {
      en: "Swiss Bar",
      ar: "السبائك السويسرية",
      href: "/swiss-bar",
      onClick: () => {
        navigate("/swiss-bar");
        setIsMenuOpen(false);
        setIsStoreMegaMenuOpen(false);
      },
    },
    { en: "PAMP Bullion", ar: "سبائك بامب", href: "/catalog/pamp-bullion" },
    {
      en: "Emirates Bullion / BTC",
      ar: "سبائك الإمارات / بي تي سي",
      href: "/catalog/emirates-bullion-btc",
    },
    { en: "Watch", ar: "ساعات", href: "/catalog/watch" },
    { en: "D'orica", ar: "دوريكا", href: "/catalog/dorica" },
    { en: "Diamond", ar: "الماس", href: "/catalog/diamond" },
    { en: "RANCANGELO", ar: "رانكانجيلو", href: "/catalog/rancangelo" },
    { en: "Monaco Chain", ar: "سلسلة موناكو", href: "/catalog/monaco-chain" },
    { en: "Platinum", ar: "البلاتين", href: "/catalog/platinum" },
    { en: "Silver", ar: "الفضة", href: "/catalog/silver" },
    {
      en: "Premium Products",
      ar: "المنتجات الفاخرة",
      href: "/catalog/premium-products",
    },
    {
      en: "Othmani Lera and Georgian",
      ar: "الليرة العثمانية والجورجية",
      href: "/catalog/othmani-lera-georgian",
    },
    { en: "Sets", ar: "مجموعات", href: "/catalog/sets" },
    { en: "White Gold", ar: "الذهب الأبيض", href: "/catalog/white-gold" },
    {
      en: "Rings & Ear Rings",
      ar: "خواتم وأقراط",
      href: "/catalog/rings-ear-rings",
    },
    { en: "Islamic", ar: "إسلامي", href: "/catalog/islamic" },
    { en: "Sabhat", ar: "سبحات", href: "/catalog/sabhat" },
    {
      en: "Bracelet & Ring",
      ar: "أساور وخواتم",
      href: "/catalog/bracelet-ring",
    },
    { en: "Bracelet", ar: "أساور", href: "/catalog/bracelet" },
    { en: "Frame", ar: "إطارات", href: "/catalog/frame" },
    { en: "Chains", ar: "سلاسل", href: "/catalog/chains" },
    {
      en: "Kids Selection",
      ar: "اختيارات الأطفال",
      href: "/catalog/kids-selection",
    },
    { en: "Gift Boxes", ar: "صناديق الهدايا", href: "/catalog/gift-boxes" },
    {
      en: "Wholesale prices",
      ar: "أسعار الجملة",
      href: "/catalog/wholesale-prices",
    },
  ];

  return (
    <nav
      className={`${
        isDarkMode ? "bg-black text-white" : "bg-white text-black"
      } ${isRTL ? "rtl" : "ltr"}`}
    >
      <hr className={`${isDarkMode ? "border-gray-700" : "border-gray-300"}`} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center h-16">
          <div className="flex">
            <div className="hidden sm:flex sm:space-x-8">
              <div className="relative group">
                <a
                  href="#store"
                  className={`${
                    isDarkMode
                      ? "text-gray-300 hover:text-yellow-500"
                      : "text-gray-700 hover:text-gray-900"
                  } px-3 py-2 rounded-md text-sm font-medium inline-flex items-center h-16 transition duration-150 ease-in-out`}
                >
                  {isRTL ? "المتجر" : "Store"}
                </a>
                <div
                  className={`absolute z-10 ${
                    isRTL ? "right-0" : "left-0"
                  } mt-0 w-64 ${
                    isDarkMode ? "bg-gray-800" : "bg-white"
                  } shadow-lg hidden group-hover:block`}
                >
                  <div className="max-h-96 overflow-y-auto">
                    <div className="grid grid-cols-2 gap-x-1 gap-y-1 p-2">
                      {storeItems.map((item, index) => (
                        <a
                          key={index}
                          href={item.href}
                          onClick={(e) => {
                            e.preventDefault();
                            item.onClick();
                          }}
                          className="text-gray-300 hover:text-yellow-500 text-xs py-1 px-2 transition duration-150 ease-in-out"
                        >
                          {isRTL ? item.ar : item.en}
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              {menuItems.map((item) => (
                <a
                  key={item.en}
                  href={item.path}
                  className={`${
                    isDarkMode
                      ? "text-gray-300 hover:text-yellow-500"
                      : "text-gray-700 hover:text-gray-900"
                  } px-3 py-2 rounded-md text-sm font-medium inline-flex items-center h-16 transition duration-150 ease-in-out`}
                >
                  {isRTL ? item.ar : item.en}
                </a>
              ))}
            </div>
          </div>
          <div className="-mr-2 flex items-center sm:hidden">
            <button
              onClick={toggleMenu}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-yellow-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white transition duration-150 ease-in-out"
            >
              <span className="sr-only">Open main menu</span>
              {isMenuOpen
                ? isRTL
                  ? "إغلاق"
                  : "Close"
                : isRTL
                ? "القائمة"
                : "Menu"}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`sm:hidden ${isMenuOpen ? "block" : "hidden"}`}>
        <div className="px-2 pt-2 pb-3 space-y-1">
          <button
            onClick={toggleStoreMegaMenu}
            className="text-gray-300 hover:text-yellow-500 block w-full text-left px-3 py-2 rounded-md text-base font-medium transition duration-150 ease-in-out"
          >
            {isRTL ? "المتجر" : "Store"}
          </button>
          {isStoreMegaMenuOpen && (
            <div className="bg-gray-800 px-4 py-2">
              <div className="max-h-60 overflow-y-auto">
                <div className="grid grid-cols-2 gap-x-2 gap-y-2">
                  {storeItems.map((item, index) => (
                    <a
                      key={index}
                      href={item.href}
                      className="text-gray-300 hover:text-yellow-500 text-sm transition duration-150 ease-in-out"
                    >
                      {isRTL ? item.ar : item.en}
                    </a>
                  ))}
                </div>
              </div>
            </div>
          )}
          {menuItems.map((item) => (
            <a
              key={item.en}
              href={item.path}
              className="text-gray-300 hover:text-yellow-500 block px-3 py-2 rounded-md text-base font-medium transition duration-150 ease-in-out"
            >
              {isRTL ? item.ar : item.en}
            </a>
          ))}
        </div>
      </div>
      <hr className={`${isDarkMode ? "border-gray-700" : "border-gray-300"}`} />
    </nav>
  );
};

export default MainNavbar;
